module.exports = __webpack_public_path__ + "static/media/preventivostickets-06-rojo.a01a849b.svg";